import {TagTextData} from '../components/tag-text/tag-text.component';
import {MainTitle} from 'projects/common/components/main-title/main-title.component';
import {OfferViewType} from 'projects/common/components/offers/offer-card-data.model';

export enum TextPosition {
  TOP = 'TOP',
  SIDE = 'SIDE',
  SIDE_REVERSED = 'SIDE_REVERSED',
  CARD = 'CARD'
}

export enum TextAlign {
  START = 'START',
  CENTER = 'CENTER',
  END = 'END'
}

export interface Module<DataType = any> extends MainTitle {
  id: string;
  presentation?: string;
  titles_outside_module?: boolean;
  pretitle?: TagTextData;
  subtitle?: TagTextData;
  title?: TagTextData;
  module_type?: string;
  position: number;
  text_position?: TextPosition;
  unique_id?: string;
  filterable?: boolean;
  ajax?: boolean;
  offer_view_type?: OfferViewType;
  detail_offer?: boolean;
  data: DataType;
  hidden?: boolean;
  track_when_displayed?: boolean;
  empty_state_data?: EmptyStateData;
  text_vertical_align?: TextAlign;
  container_styles?: { [key: string]: string };
  logo?: {
    src: string;
  };
  /** @description Informative module metadata */
  metadata?: ModuleMetadata;
  // Campo para trackear a Upa, se completa en nymeria-gui, del lado de Angular
  row_number: number;
  background_module?: BackgroundModule;
}

type ModuleMetadata = {
  module_configuration_from_db: { [key: string]: string };
  metabase_url: string;
  debug_info: DebugInfo;
}

export interface DebugInfo {
  requests: RequestInfo[],
  exceptions: string[]
}

export interface RequestInfo {
  request_headers: Record<string, string>,
  response_headers: Record<string, string>,
  method: string,
  url: string,
  response_code: string,
  error_message: string,
}

export interface BrowserStorageModel {
  storage_type: BrowserStorageType,
  key: string,
  value: string
}

export type BrowserStorageType = 'LOCAL' | 'SESSION'

export interface BackgroundModule {
  image: string;
  color: string;
  type: BackgroundModuleType | string;
}

export type BackgroundModuleType = 'FULL_WIDTH' | 'CONTENT_WIDTH';

export interface EmptyStateData {
  shared_module_id: string;
  group_number: number;
  show_title: boolean;
  ajax_response: boolean;
}